const initialState = {
  resultsAnalyticsHighlights: null,
  errorAnalyticsHighlights: false,
  currentHotelUuid: null,
};
const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "ANALYTICS_HIGHLIGHTS_RESPONSE_GET":
      newState.resultsAnalyticsHighlights = action.value;
      newState.errorAnalyticsHighlights = action.value?.responseStatus === "error" ? true : false;
      newState.currentHotelUuid = action.uuid;
      break;
    case "ANALYTICS_HIGHLIGHTS_RESPONSE_RESET":
      return {
        ...initialState,
        resultsAnalyticsHighlights: null,
        currentHotelUuid: null,
        errorAnalyticsHighlights: false
      };
    default:
      break;
  }
  return newState;
}

export default reducer;
